import { useMutation, useQueryClient } from '@tanstack/react-query';

import { completeGuideItem } from '../api/guide.api';
import { GUIDE_STATUS_QUERY_KEY } from '../constants/guide-query-keys';

export const useCompleteGuideItem = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (item: string) => completeGuideItem(item),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: GUIDE_STATUS_QUERY_KEY });
    },
  });
};
